// https://github.com/Unidata/MetPy/blob/main/src/metpy/io/nexrad.py

const MaxRanges = {
    30: 230,
    56: 230,
    58: 460,
    59: 230,
    61: 230,
    62: 460,
    78: 230,
    80: 230,
    94: 460,
    99: 300,
    134: 460,
    141: 230,
    153: 460,
    154: 300,
    159: 300,
    161: 300,
    165: 300,
    170: 230,
    172: 230,
    177: 230,
    180: 90,
    182: 90,
    186: 416
}

module.exports = MaxRanges;